function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMulti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.104 -6.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4.736,
    x: 13.104,
    y: 6.85,
    ry: 0.738,
    style: {
      fill: "#60725b",
      fillOpacity: 1,
      strokeWidth: 0.143947
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4.736,
    x: 13.104,
    y: 12.444,
    ry: 0.738,
    style: {
      fill: "#60725b",
      fillOpacity: 1,
      strokeWidth: 0.143947
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4.736,
    x: 13.104,
    y: 18.121,
    ry: 0.738,
    style: {
      fill: "#60725b",
      fillOpacity: 1,
      strokeWidth: 0.143947
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulti);
export default __webpack_public_path__ + "static/media/multi.677d46fd4e248d969d58c7b028d54c8f.svg";
export { ForwardRef as ReactComponent };